// GCK-20835: o detalhe do contrato usa o shell próprio do portal (PortalLayout)
const routes = [
    {
        path: '/area_cliente/contratos/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]

export default routes
